import { render, staticRenderFns } from "./ExportRendicontazioneVeneto.vue?vue&type=template&id=60dd4a16&"
import script from "./ExportRendicontazioneVeneto.vue?vue&type=script&lang=js&"
export * from "./ExportRendicontazioneVeneto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports